import axios from 'axios';

export const API_BASE_URL = String(import.meta.env.VITE_API_BASE_URL ?? '');

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    const message = error.response?.data?.message;
    if (typeof message === 'string') {
      return message;
    }
    if (Array.isArray(message)) {
      return message.join('. ');
    }
  }
  return fallback;
};
